import React, { useState } from "react";
import Select from "../../components/select/Select";
import "./VirtualMainForm.css";

const VirtualMainForm = (props) => {
  //useEffect(() => {}, [props]);
  const [distances] = useState([
    { key: "distance1", title: "Distance 1" },
    { key: "distance2", title: "Distance 2" },
  ]);

  /* if (
    props.virtualState.exerciseSteps[0].repDetect[0].extensions[0] &&
    Object.keys(props.virtualState.exerciseSteps[0].repDetect[0].extensions[0])[0] === "extensionAngle"
  ) {
    console.log("zzzz");
  } else if (
    props.virtualState.exerciseSteps[0].repDetect[0].extensions[0] &&
    Object.keys(props.virtualState.exerciseSteps[0].repDetect[0].extensions[0])[0] === "extensionPoint"
  ) {
    console.log("sssss");
  } */
  // eslint-disable-next-line
  const [jointNum] = useState([{ number: 0 }, { number: 1 }, { number: 2 }, { number: 3 }, { number: 4 }]);
  const [detectPointsInx] = useState([{ inx: 0 }, { inx: 1 }, { inx: 2 }, { inx: 3 }, { inx: 4 }, { inx: 5 }]);

  const [focusedIndex, setFocusedIndex] = useState(-1);

  const handleFocus = (index) => {
    setFocusedIndex(index);
  };
  // eslint-disable-next-line
  const toNormalCase = (param) => {
    var newStr = "";
    if (typeof param === "string") {
      newStr = param.split(/(?=[A-Z])/);
      let splitFurther = newStr[0].split("");
      splitFurther[0] = splitFurther[0].toUpperCase();
      splitFurther = splitFurther.join("");
      newStr[0] = splitFurther;
      newStr = newStr.join(" ");
    }
    return newStr;
  };

  const options1 = [{ value: "Time" }, { value: "Rep" }];

  const options3 = [{ value: "MustBeAtSameY" }, { value: "MustBeHigherThan" }];

  return (
    <div>
      <div className="left_side_inputs_container">
        <div className="three_items_row_container">
          <div className="e_create_input vt_inp_detached select_main virtual_inpts_width">
            {props.virtualState.key && props.virtualState.key.length > 0 && (
              <div className="select_placeholder sp_act">Key</div>
            )}
            <input
              type="text"
              value={props.virtualState.key}
              placeholder="Key"
              className={
                props.virtualState.key && props.virtualState.key.length > 0
                  ? " "
                  : "vt_input_inact"
              }
              onChange={(e) =>
                props.handleTopVals("key", e.currentTarget.value)
              }
            />
          </div>
          <div className="e_create_input vt_inp_detached select_main virtual_inpts_width">
            {props.virtualVal.exerciseType &&
              props.virtualVal.exerciseType.length > 0 && (
                <div className="select_placeholder sp_act">Exercise Type</div>
              )}
            <input
              type="text"
              value={props.virtualVal.exerciseType}
              placeholder="Exercise Type"
              className={
                props.virtualVal.exerciseType &&
                props.virtualVal.exerciseType.length > 0
                  ? " "
                  : "vt_input_inact"
              }
              onChange={(e) =>
                props.getVirtualStates("exerciseType", e.currentTarget.value)
              }
            />
          </div>
          <div
            className="e_create_input vt_inp_detached select_main virtual_inpts_width"
            style={{ display: "inline-block" }}
          >
            {props.virtualVal.defaultTime &&
              props.virtualVal.defaultTime.length > 0 && (
                <div className="select_placeholder sp_act">Default Time</div>
              )}
            <input
              type="text"
              value={props.virtualVal.defaultTime}
              placeholder="Default Time"
              className={
                props.virtualVal.defaultTime.length > 0 ? " " : "vt_input_inact"
              }
              onChange={(e) =>
                props.getVirtualStates("defaultTime", e.currentTarget.value)
              }
            />
          </div>
        </div>

        <div className="three_items_row_container">
          <div className="e_create_input vt_inp_detached select_main virtual_inpts_width">
            {props.virtualVal.virtualVideoUrl &&
              props.virtualVal.virtualVideoUrl.length > 0 && (
                <div className="select_placeholder sp_act">
                  Virtual Video URL
                </div>
              )}
            <input
              type="text"
              value={props.virtualVal.virtualVideoUrl}
              placeholder="Virtual Video URL"
              className={
                props.virtualVal.virtualVideoUrl.length > 0
                  ? " "
                  : "vt_input_inact"
              }
              onChange={(e) =>
                props.getVirtualStates("virtualVideoUrl", e.currentTarget.value)
              }
            />
          </div>
          <div className="e_create_input vt_inp_detached select_main virtual_inpts_width">
            {props.virtualVal.defaultHoldTime &&
              props.virtualVal.defaultHoldTime > 0 && (
                <div className="select_placeholder sp_act">
                  Default Hold Time
                </div>
              )}
            <input
              type="number"
              value={props.virtualVal.defaultHoldTime}
              placeholder="Default Hold Time"
              className={
                props.virtualVal.defaultHoldTime > 0 ? " " : "vt_input_inact"
              }
              onChange={(e) =>
                props.getVirtualStates("defaultHoldTime", e.currentTarget.value)
              }
            />
          </div>

          <div className="e_create_input vt_inp_detached select_main virtual_inpts_width">
            {props.virtualState.displayName &&
              props.virtualState.displayName.length > 0 && (
                <div className="select_placeholder sp_act">Display Name</div>
              )}
            <input
              type="text"
              value={props.virtualState.displayName}
              placeholder="Display Name"
              className={
                props.virtualState.displayName.length > 0
                  ? " "
                  : "vt_input_inact"
              }
              onChange={(e) =>
                props.handleTopVals("displayName", e.currentTarget.value)
              }
            />
          </div>
        </div>

        <div className="three_items_row_container">
          <div className="e_create_input vt_inp_detached select_main virtual_inpts_width">
            {props.virtualVal.exerciseLevel &&
              props.virtualVal.exerciseLevel.length > 0 && (
                <div className="select_placeholder sp_act">Exercise Level</div>
              )}
            <input
              type="text"
              value={props.virtualVal.exerciseLevel}
              placeholder="Exercise Level"
              className={
                props.virtualVal.exerciseLevel &&
                props.virtualVal.exerciseLevel.length > 0
                  ? " "
                  : "vt_input_inact"
              }
              onChange={(e) =>
                props.getVirtualStates("exerciseLevel", e.currentTarget.value)
              }
            />
          </div>

          <div className="e_create_input vt_inp_detached select_main virtual_inpts_width">
            {props.virtualVal.defaultSets &&
              props.virtualVal.defaultSets > 0 && (
                <div className="select_placeholder sp_act">Default Sets</div>
              )}
            <input
              type="number"
              value={props.virtualVal.defaultSets}
              placeholder="Default Sets"
              className={
                props.virtualVal.defaultSets > 0 ? " " : "vt_input_inact"
              }
              onChange={(e) =>
                props.getVirtualStates("defaultSets", e.currentTarget.value)
              }
            />
          </div>
          <div className="e_create_input vt_inp_detached select_main virtual_inpts_width">
            {props.virtualVal.virtualImageUrl &&
              props.virtualVal.virtualImageUrl.length > 0 && (
                <div className="select_placeholder sp_act">
                  Virtual Image URL
                </div>
              )}
            <input
              type="text"
              value={props.virtualVal.virtualImageUrl}
              placeholder="Virtual Image URL"
              className={
                props.virtualVal.virtualImageUrl.length > 0
                  ? " "
                  : "vt_input_inact"
              }
              onChange={(e) =>
                props.getVirtualStates("virtualImageUrl", e.currentTarget.value)
              }
            />
          </div>
        </div>
        <div className="three_items_row_container">
          <div className="select_virtual_sub_prob">
            <Select
              placeholder="Time/Rep based"
              selectOptions={options1}
              initVal={
                props.virtualVal.time_rep_based !== ""
                  ? props.virtualVal.time_rep_based
                  : ""
              }
              selectCallback={props.getVirtualStates}
              callBackValue={"time_rep_based"}
            />
          </div>
          <div className="vt_select_detached virtual_inpts_width vt_hold_padd">
            <div className="vt_select_inline">Hold</div>
            <div
              className={
                "vt_check repeats_checkbox " +
                (props.virtualState.isHold ? "repeats_checked" : "")
              }
              onClick={() =>
                props.handleTopVals("isHold", !props.virtualState.isHold)
              }
            ></div>
          </div>
          <div className="e_create_input vt_inp_detached select_main virtual_inpts_width">
            {props.virtualVal.defaultReps &&
              props.virtualVal.defaultReps > 0 && (
                <div className="select_placeholder sp_act">Default Reps</div>
              )}
            <input
              type="number"
              value={props.virtualVal.defaultReps}
              placeholder="Default Reps"
              className={
                props.virtualVal.defaultReps > 0 ? " " : "vt_input_inact"
              }
              onChange={(e) =>
                props.getVirtualStates("defaultReps", e.currentTarget.value)
              }
            />
          </div>
        </div>
        <div className="select_virtual_sub_prob">
          <Select
            placeholder="Sub Problem ID"
            selectOptions={props.subProbIds}
            initVal={
              props.virtualVal.subProblemId !== ""
                ? props.virtualVal.subProblemId
                : ""
            }
            selectCallback={props.getVirtualStates}
            callBackValue={"subProblemId"}
          />
        </div>
      </div>
      <div className="virtual_hold start_position_container">
        <div className="vth_title">Start Position</div>
        <div className="three_items_row_container">
        <div className="conditions_select conditions_inpt_select">
          <Select
            placeholder="Predefined Start Position"
            initVal={
              props.virtualVal.predefined_start_pos !== ""
                ? props.virtualVal.predefined_start_pos
                : ""
            }
            selectOptions={props.positionOptions}
            selectCallback={props.addStartPosition}
            callBackValue={true}
          />
        </div>
        <div
          className="e_create_input vt_inp_detached select_main conditions_inpt_width"
          style={{ display: "block" }}
        >
          {props.virtualState.startPosition.audioInstructions &&
            props.virtualState.startPosition.audioInstructions.length > 0 && (
              <div className="select_placeholder sp_act">
                Start Audio Instructions
              </div>
            )}
          <input
            type="text"
            value={props.virtualState.startPosition.audioInstructions}
            placeholder="Start Audio Instructions"
            className={
              props.virtualState.startPosition.audioInstructions &&
              props.virtualState.startPosition.audioInstructions.length > 0
                ? " "
                : "vt_input_inact"
            }
            onChange={(e) =>
              props.handleObjVals(
                ["startPosition", "audioInstructions"],
                e.currentTarget.value
              )
            }
          />
        </div>
        </div>
        {/* <div className="vt_inp_included select_main">
          <div className="select_placeholder sp_act">Position landmark key</div>
          <input
            type="text"
            value={props.virtualState.startPosition.targetLandmarks}
            onChange={(e) => props.handleObjVals(["startPosition", "targetLandmarks"], e.currentTarget.value)}
          />
        </div>
        <div className="vt_inp_included select_main">
          <div className="select_placeholder sp_act">On screen text instructions</div>
          <input
            type="text"
            value={props.virtualState.startPosition.screenInstructions}
            onChange={(e) => props.handleObjVals(["startPosition", "screenInstructions"], e.currentTarget.value)}
          />
        </div>
        <div className="vt_inp_included select_main select_longform">
          <div className="select_placeholder sp_act">Target Joints</div>
          {jointNum.map((jNum, jo) => (
            <div key={jo} className="vt_select_hold vt_mpipe_s_short">
              <Select
                initVal={
                  props.virtualState.startPosition.targetJoints
                    ? toNormalCase(props.virtualState.startPosition.targetJoints[jNum.number])
                    : ""
                }
                placeholder="Joint"
                selectOptions={props.joints}
                selectCallback={props.handleArrVals}
                callBackValue={["startPosition", "targetJoints", jNum.number]}
              />
            </div>
          ))}
        </div>
        <div className="vt_inp_included select_main">
          <div className="select_placeholder sp_act">Target Level (%)</div>
          <input
            type="text"
            value={Math.round(props.virtualState.startPosition.targetLevel * 100)}
            onChange={(e) => props.handleObjVals(["startPosition", "targetLevel"], e.currentTarget.value)}
          />
        </div>
        <div className="vt_inp_included select_main">
          <div className="select_placeholder sp_act">Audio Instructions</div>
          <input
            type="text"
            value={props.virtualState.startPosition.audioInstructions}
            onChange={(e) => props.handleObjVals(["startPosition", "audioInstructions"], e.currentTarget.value)}
          />
        </div>
        <div className="vt_inp_included select_main">
          <div className="select_placeholder sp_act">Start exercise after seconds</div>
          <input
            type="text"
            value={props.virtualState.startPosition.moveToNextCountdown}
            onChange={(e) => props.handleObjVals(["startPosition", "moveToNextCountdown"], e.currentTarget.value, true)}
          />
        </div>
        <div className="vt_inp_included select_main">
          <div className="select_placeholder sp_act">Replay Audio after seconds</div>
          <input
            type="text"
            value={props.virtualState.startPosition.audioReplay}
            onChange={(e) => props.handleObjVals(["startPosition", "audioReplay"], e.currentTarget.value, true)}
          />
        </div> */}
      </div>
      <div className="virtual_hold start_position_container">
        <div className="vth_title">Conditions</div>
        {props.virtualState.exerciseSteps[0] &&
          props.virtualState.exerciseSteps[0].repDetect[0].requirements.map(
            (item, i) => (
              <div key={i}>
                <div className="conditions_select conditions_inpt_select">
                  <Select
                    selectOptions={options3}
                    initVal={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .requirements[i].cType !== ""
                        ? props.virtualState.exerciseSteps[0].repDetect[0]
                            .requirements[i].cType
                        : ""
                    }
                    selectCallback={props.handleNewArrVals}
                    callBackValue={[
                      "exerciseSteps",
                      "repDetect",
                      "requirements",
                      i,
                    ]}
                  />
                </div>
                <div className="conditions_select conditions_inpt_select">
                  <Select
                    selectOptions={props.joints}
                    initVal={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .requirements[i].landmarks[0] !== ""
                        ? props.virtualState.exerciseSteps[0].repDetect[0]
                            .requirements[i].landmarks[0]
                        : ""
                    }
                    selectCallback={props.handleNewArrVals}
                    callBackValue={[
                      "exerciseSteps",
                      "repDetect",
                      "requirements",
                      i,
                      0,
                    ]}
                  />
                </div>
                <div className="conditions_select conditions_inpt_select">
                  <Select
                    selectOptions={props.joints}
                    initVal={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .requirements[i].landmarks[1] !== ""
                        ? props.virtualState.exerciseSteps[0].repDetect[0]
                            .requirements[i].landmarks[1]
                        : ""
                    }
                    selectCallback={props.handleNewArrVals}
                    callBackValue={[
                      "exerciseSteps",
                      "repDetect",
                      "requirements",
                      i,
                      1,
                    ]}
                  />
                </div>
                <div className="e_create_input vt_inp_detached select_main conditions_inpt_select conditions_inpt_width">
                  {props.virtualState.exerciseSteps[0].repDetect[0]
                    .requirements[i].tolerance !== null &&
                    props.virtualState.exerciseSteps[0].repDetect[0]
                      .requirements[i].tolerance.length > 0 && (
                      <div className="select_placeholder sp_act">
                        Tolerance %
                      </div>
                    )}
                  <input
                    type="number"
                    value={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .requirements[i].tolerance
                    }
                    placeholder="Tolerance %"
                    className={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .requirements[i].tolerance.length > 0
                        ? " "
                        : "vt_input_inact"
                    }
                    onChange={(e) =>
                      props.handleNewArrVals(
                        ["exerciseSteps", "repDetect", "requirements", i],
                        parseFloat(e.currentTarget.value)
                      )
                    }
                  />
                </div>
              </div>
            )
          )}
        <div className="vt_add" onClick={() => props.addConditions()}>
          Add Conditions
        </div>
        <div className="vth_title">Extensions Points</div>
        {props.virtualState.exerciseSteps[0].repDetect[0].extensions[0] &&
          Object.keys(
            props.virtualState.exerciseSteps[0].repDetect[0].extensions[0]
          )[0] === "extensionPoint" &&
          props.virtualState.exerciseSteps[0].repDetect[0].extensions.map(
            (item, k) => (
              <div key={k}>
                <div className="conditions_select conditions_inpt_select">
                  <Select
                    selectOptions={props.joints}
                    initVal={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .extensions[k].extensionPoint !== ""
                        ? props.virtualState.exerciseSteps[0].repDetect[0]
                            .extensions[k].extensionPoint
                        : ""
                    }
                    selectCallback={props.handleNewArrVals}
                    callBackValue={[
                      "exerciseSteps",
                      "repDetect",
                      "extensions",
                      k,
                    ]}
                  />
                </div>
                <div className="e_create_input vt_inp_detached select_main conditions_inpt_select conditions_inpt_width">
                  {props.virtualState.exerciseSteps[0].repDetect[0].extensions[
                    k
                  ].startVal !== null &&
                    props.virtualState.exerciseSteps[0].repDetect[0].extensions[
                      k
                    ].startVal.length > 0 && (
                      <div className="select_placeholder sp_act">
                        Start Angle
                      </div>
                    )}
                  <input
                    type="number"
                    value={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .extensions[k].startVal
                    }
                    placeholder="Start Angle"
                    className={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .extensions[k].startVal.length > 0
                        ? " "
                        : "vt_input_inact"
                    }
                    onChange={(e) =>
                      props.handleNewArrVals(
                        [
                          "exerciseSteps",
                          "repDetect",
                          "extensions",
                          k,
                          "start",
                        ],
                        parseFloat(e.currentTarget.value)
                      )
                    }
                  />
                </div>
                <div className="e_create_input vt_inp_detached select_main conditions_inpt_select conditions_inpt_width">
                  {props.virtualState.exerciseSteps[0].repDetect[0].extensions[
                    k
                  ].targetVal !== null &&
                    props.virtualState.exerciseSteps[0].repDetect[0].extensions[
                      k
                    ].targetVal.length > 0 && (
                      <div className="select_placeholder sp_act">
                        Target Angle
                      </div>
                    )}
                  <input
                    type="number"
                    value={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .extensions[k].targetVal
                    }
                    placeholder="Target Angle"
                    className={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .extensions[k].targetVal.length > 0
                        ? " "
                        : "vt_input_inact"
                    }
                    onChange={(e) =>
                      props.handleNewArrVals(
                        [
                          "exerciseSteps",
                          "repDetect",
                          "extensions",
                          k,
                          "target",
                        ],
                        parseFloat(e.currentTarget.value)
                      )
                    }
                  />
                </div>
              </div>
            )
          )}
        <div className="vt_add" onClick={() => props.addExtensions(["point"])}>
          Add Extensions Points
        </div>
        <div className="vth_title">Extensions Angle</div>
        {props.virtualState.exerciseSteps[0].repDetect[0].extensions[0] &&
          Object.keys(
            props.virtualState.exerciseSteps[0].repDetect[0].extensions[0]
          )[0] === "extensionAngle" &&
          props.virtualState.exerciseSteps[0].repDetect[0].extensions.map(
            (item, i) => (
              <div key={i}>
                <div className="conditions_select conditions_inpt_select">
                  <Select
                    selectOptions={props.mediaPipePoints}
                    initVal={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .extensions[i].extensionAngle[0] !== ""
                        ? props.virtualState.exerciseSteps[0].repDetect[0]
                            .extensions[i].extensionAngle[0]
                        : ""
                    }
                    selectCallback={props.handleNewArrVals}
                    callBackValue={[
                      "exerciseSteps",
                      "repDetect",
                      "extensions",
                      i,
                      "angle1",
                    ]}
                  />
                </div>
                <div className="conditions_select conditions_inpt_select">
                  <Select
                    selectOptions={props.mediaPipePoints}
                    initVal={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .extensions[i].extensionAngle[1] !== ""
                        ? props.virtualState.exerciseSteps[0].repDetect[0]
                            .extensions[i].extensionAngle[1]
                        : ""
                    }
                    selectCallback={props.handleNewArrVals}
                    callBackValue={[
                      "exerciseSteps",
                      "repDetect",
                      "extensions",
                      i,
                      "angle2",
                    ]}
                  />
                </div>
                <div className="conditions_select conditions_inpt_select">
                  <Select
                    selectOptions={props.mediaPipePoints}
                    initVal={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .extensions[i].extensionAngle[2] !== ""
                        ? props.virtualState.exerciseSteps[0].repDetect[0]
                            .extensions[i].extensionAngle[2]
                        : ""
                    }
                    selectCallback={props.handleNewArrVals}
                    callBackValue={[
                      "exerciseSteps",
                      "repDetect",
                      "extensions",
                      i,
                      "angle3",
                    ]}
                  />
                </div>
                <div className="e_create_input vt_inp_detached select_main conditions_inpt_select conditions_inpt_width">
                  {props.virtualState.exerciseSteps[0].repDetect[0].extensions[
                    i
                  ].startVal !== null &&
                    props.virtualState.exerciseSteps[0].repDetect[0].extensions[
                      i
                    ].startVal.length > 0 && (
                      <div className="select_placeholder sp_act">
                        Start Angle
                      </div>
                    )}
                  <input
                    type="number"
                    value={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .extensions[i].startVal
                    }
                    placeholder="Start Angle"
                    className={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .extensions[i].startVal.length > 0
                        ? " "
                        : "vt_input_inact"
                    }
                    onChange={(e) =>
                      props.handleNewArrVals(
                        [
                          "exerciseSteps",
                          "repDetect",
                          "extensions",
                          i,
                          "start",
                        ],
                        parseFloat(e.currentTarget.value)
                      )
                    }
                  />
                </div>
                <div className="e_create_input vt_inp_detached select_main conditions_inpt_select conditions_inpt_width">
                  {props.virtualState.exerciseSteps[0].repDetect[0].extensions[
                    i
                  ].targetVal !== null &&
                    props.virtualState.exerciseSteps[0].repDetect[0].extensions[
                      i
                    ].targetVal.length > 0 && (
                      <div className="select_placeholder sp_act">
                        Target Angle
                      </div>
                    )}
                  <input
                    type="number"
                    value={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .extensions[i].targetVal
                    }
                    placeholder="Target Angle"
                    className={
                      props.virtualState.exerciseSteps[0].repDetect[0]
                        .extensions[i].targetVal.length > 0
                        ? " "
                        : "vt_input_inact"
                    }
                    onChange={(e) =>
                      props.handleNewArrVals(
                        [
                          "exerciseSteps",
                          "repDetect",
                          "extensions",
                          i,
                          "target",
                        ],
                        parseFloat(e.currentTarget.value)
                      )
                    }
                  />
                </div>
              </div>
            )
          )}
        <div className="vt_add" onClick={() => props.addExtensions(["angle"])}>
          Add Extensions Angle
        </div>
      </div>
      <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: '10px'}}>
      <div className="e_create_input vt_inp_detached select_main">
        {props.virtualState.currentStep !== undefined &&
          props.virtualState.currentStep !== null && (
            <div className="select_placeholder sp_act">
              Start Step (0, 1,...)
            </div>
          )}
        {props.virtualState.currentStep > -1 && (
          <input
            type="text"
            value={props.virtualState.currentStep}
            placeholder={
              props.virtualState.currentStep === null
                ? "Start Step (0, 1,...)"
                : ""
            }
            className={
              props.virtualState.currentStep !== null ? " " : "vt_input_inact"
            }
            onChange={(e) =>
              props.handleTopVals("currentStep", e.currentTarget.value, true)
            }
          />
        )}
      </div>
      <div className="vt_select_detached">
        <div className="vt_select_inline">Detect Any Step</div>
        <div
          className={
            "vt_check repeats_checkbox " +
            (props.virtualState.detectAnyStep ? "repeats_checked" : "")
          }
          onClick={() =>
            props.handleTopVals(
              "detectAnyStep",
              !props.virtualState.detectAnyStep
            )
          }
        ></div>
      </div>
      </div>
      <div className={"virtual_hold" + (props.errorStep ? " sb_sec_err" : " ")}>
        <div className="vth_title">Exercise Steps</div>
        <div className="three_items_row_container">
          <div className="exercise_steps_row_w select_virtual_sub_prob">
            <Select
              placeholder="Step Type"
              selectOptions={[
                { value: "positionDetect" },
                { value: "targetPosition" },
              ]}
              initVal={
                props.virtualState.exerciseSteps[0] &&
                props.virtualState.exerciseSteps[0].detectType !== ""
                  ? props.virtualState.exerciseSteps[0].detectType
                  : ""
              }
              selectCallback={props.handleNewArrVals}
              callBackValue={["stepType"]}
            />
          </div>
          <div className="exercise_steps_row_correct e_create_input vt_inp_detached select_main">
            {props.virtualState.exerciseSteps[0] &&
              props.virtualState.exerciseSteps[0].targetPosition.length > 0 && (
                <div className="select_placeholder sp_act">Target Position</div>
              )}
            <input
              type="text"
              value={
                props.virtualState.exerciseSteps[0]
                  ? props.virtualState.exerciseSteps[0].targetPosition
                  : ""
              }
              onChange={(e) =>
                props.handleNewArrVals(
                  ["targetPosition"],
                  e.currentTarget.value
                )
              }
            />
          </div>
          <div className="exercise_steps_row_correct e_create_input vt_inp_detached select_main">
            {true && (
              <div className="select_placeholder sp_act">
                Minimum % for step
              </div>
            )}
            <input
              type="number"
              value={
                props.virtualState.exerciseSteps[0]
                  ? props.virtualState.exerciseSteps[0].minimumLevel
                  : ""
              }
              placeholder="Minimum level"
              className={
                props.virtualState.exerciseSteps[0]
                  ? props.virtualState.exerciseSteps[0].minimumLevel > 0
                    ? " "
                    : "vt_input_inact"
                  : ""
              }
              onChange={(e) =>
                props.handleNewArrVals(["minimumLevel"], e.currentTarget.value)
              }
            />
          </div>
        </div>
        <div className="three_items_row_container" style={{marginTop: '10px'}}>
          <div className="exercise_steps_row_correct vt_select_detached vt_hold_padd">
            <div className="vt_select_inline">Detect Any</div>
            <div
              className={
                "vt_check repeats_checkbox " +
                (props.virtualState.exerciseSteps[0] &&
                props.virtualState.exerciseSteps[0].detectAny
                  ? "repeats_checked"
                  : "")
              }
              onClick={() =>
                props.handleNewArrVals(
                  ["detectAny"],
                  !props.virtualState.exerciseSteps[0].detectAny
                )
              }
            ></div>
          </div>
          <div className="exercise_steps_row_w select_virtual_sub_prob">
            <Select
              placeholder="Camera Rotation"
              selectOptions={[
                { value: "standingStraight" },
                { value: "onHandsAndKnees" },
                { value: "lyingFaceDown" },
                { value: "lyingFaceUp" },
              ]}
              initVal={
                props.virtualState.exerciseSteps[0]
                  ? props.virtualState.exerciseSteps[0].cameraRotation
                  : ""
              }
              selectCallback={props.handleNewArrVals}
              callBackValue={["cameraRotation"]}
            />
          </div>
        </div>
        {props.virtualState.exerciseSteps[0] &&
          props.virtualState.exerciseSteps[0].positionDetect.map((item, i) => (
            <div key={i} className="vt_step_hold">
              {/* <div className={"vt_select_hold" + (item.detectType === "targetPosition" ? " vts_block" : "")}>
              <Select
                initVal={item.detectType === "targetPosition" ? "Target Position" : "Position Detect"}
                placeholder="Step Type"
                selectOptions={[{ value: "Target Position" }, { value: "Position Detect" }]}
                selectCallback={props.handleArrVals}
                callBackValue={["exerciseSteps", i, "detectType"]}
              />
            </div> */}
              <>
                {/* <div className="vt_inp_included select_main">
                <div className="select_placeholder sp_act">Target position landmark key</div>
                <input
                  type="text"
                  value={item.targetPosition}
                  onChange={(e) => props.handleArrVals(["exerciseSteps", i, "targetPosition"], e.currentTarget.value)}
                />
              </div> */}
                {/* <div className="vt_inp_included select_main">
                <div className="select_placeholder sp_act">Minimum % for step</div>
                <input
                  type="text"
                  value={Math.round(item.minimumLevel * 100)}
                  onChange={(e) =>
                    props.handleArrVals(["exerciseSteps", i, "minimumLevel"], e.currentTarget.value, true)
                  }
                />
              </div> */}
              </>
              {props.virtualState.exerciseSteps[0].detectType ===
                "positionDetect" && (
                <>
                  {/* <div className="vt_select_hold">
                  <Select
                    initVal={item.detectAny ? "Any" : "All"}
                    placeholder="Detect"
                    selectOptions={[{ value: "Any" }, { value: "All" }]}
                    selectCallback={props.handleArrVals}
                    callBackValue={["exerciseSteps", i, "detectAny"]}
                  />
                </div> */}
                  <div className="vt_select_hold">
                    <Select
                      initVal={
                        props.virtualState.exerciseSteps[0].positionDetect[i]
                          .type === "crossLine"
                          ? "Line"
                          : props.virtualState.exerciseSteps[0].positionDetect[
                              i
                            ].type === "comparePoints"
                          ? "Points"
                          : props.virtualState.exerciseSteps[0].positionDetect[
                              i
                            ].type === "insideGraphic"
                          ? "Graphics"
                          : props.virtualState.exerciseSteps[0].positionDetect[
                              i
                            ].type === "doActions"
                          ? "Do Action"
                          : props.virtualState.exerciseSteps[0].positionDetect[
                              i
                            ].type === "acAction"
                          ? "Ac Action"
                          : ""
                      }
                      placeholder="Position Detect Type"
                      selectOptions={[
                        { value: "Line", key: "crossLine" },
                        { value: "Points", key: "comparePoints" },
                        { value: "Graphics", key: "insideGraphic" },
                        { value: "Do Action", key: "doActions" },
                        { value: "Ac Action", key: "acAction" },
                      ]}
                      selectCallback={
                        item.positionDetect && item.positionDetect.length === 0
                          ? function (callval, poseType) {
                              props.addGraphOrAction([
                                "exerciseSteps",
                                i,
                                "positionDetect",
                                poseType,
                              ]);
                            }
                          : props.handleArrSubVals
                      }
                      callBackValue={[
                        "exerciseSteps",
                        i,
                        "positionDetect",
                        0,
                        "type",
                      ]}
                    />
                  </div>
                </>
              )}
              {props.virtualState.exerciseSteps[0].detectType ===
                "positionDetect" &&
                props.virtualState.exerciseSteps[0].positionDetect.map(
                  (pose, p) => (
                    <>
                      {/* {false && (
                      <div className="vt_select_hold">
                        <Select
                          initVal={
                            pose.type === "crossLine"
                              ? "Line"
                              : pose.type === "comparePoints"
                              ? "Points"
                              : pose.type === "insideGraphic"
                              ? "Graphics"
                              : ""
                          }
                          placeholder="Position Detect Type"
                          selectOptions={[
                            { value: "Line", key: "crossLine" },
                            { value: "Points", key: "comparePoints" },
                            { value: "Graphics", key: "insideGraphic" },
                          ]}
                          selectCallback={props.handleArrSubVals}
                          callBackValue={["exerciseSteps", i, "positionDetect", p, "type"]}
                        />
                      </div>
                    )} */}
                      {pose.type === "crossLine" && i === p ? (
                        <div key={p} className="vt_main_pose_hold">
                          <div className="vt_select_hold vt_mpipe_s_short_extr">
                            <Select
                              initVal={pose.direction}
                              placeholder="Direction"
                              selectOptions={[{ value: "x" }, { value: "y" }]}
                              selectCallback={props.handleArrSubVals}
                              callBackValue={[
                                "exerciseSteps",
                                i,
                                "positionDetect",
                                p,
                                "direction",
                              ]}
                            />
                          </div>
                          <div className="vt_select_hold vt_mpipe_s_short">
                            <Select
                              initVal={
                                pose.relativeTo === "graphic"
                                  ? "Graphic"
                                  : pose.relativeTo === "mediaPipePoint"
                                  ? "Media Pipe Point"
                                  : ""
                              }
                              placeholder="Relative to"
                              selectOptions={[
                                { value: "Graphic", key: "graphic" },
                                {
                                  value: "Media Pipe Point",
                                  key: "mediaPipePoint",
                                },
                              ]}
                              selectCallback={props.handleArrSubVals}
                              callBackValue={[
                                "exerciseSteps",
                                i,
                                "positionDetect",
                                p,
                                "relativeTo",
                              ]}
                            />
                          </div>
                          <div className="vt_inp_included select_main">
                            <div className="select_placeholder sp_act">
                              Item Index
                            </div>
                            <input
                              type="text"
                              value={pose.itemIndex}
                              onChange={(e) =>
                                props.handleArrSubVals(
                                  [
                                    "exerciseSteps",
                                    i,
                                    "positionDetect",
                                    p,
                                    "itemIndex",
                                  ],
                                  e.currentTarget.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="vt_select_hold vt_mpipe_s_short">
                            <Select
                              initVal={pose.itemIndexXY ? pose.itemIndexXY : ""}
                              placeholder="Item Index XY"
                              selectOptions={[
                                { value: "x1" },
                                { value: "y1" },
                                { value: "x2" },
                                { value: "y2" },
                              ]}
                              selectCallback={props.handleArrSubVals}
                              callBackValue={[
                                "exerciseSteps",
                                i,
                                "positionDetect",
                                p,
                                "itemIndexXY",
                              ]}
                            />
                          </div>
                          <div className="vt_select_hold vt_mpipe_s_short">
                            <Select
                              initVal={
                                props.mediaPipePoints[
                                  pose.detectPoint &&
                                  pose.detectPoint[0] !== undefined
                                    ? pose.detectPoint[0]
                                    : 0
                                ].value
                              }
                              placeholder="Detect Point 1"
                              selectOptions={props.mediaPipePoints}
                              selectCallback={props.handleArrSubVals}
                              callBackValue={[
                                "exerciseSteps",
                                i,
                                "positionDetect",
                                p,
                                "detectPoint",
                                0,
                              ]}
                            />
                          </div>
                          <div className="vt_select_hold vt_mpipe_s_short">
                            <Select
                              initVal={
                                pose.detectPoint &&
                                pose.detectPoint[1] !== undefined
                                  ? pose.detectPoint[1]
                                  : "x1"
                              }
                              placeholder="Detect Point 2"
                              selectOptions={[{ value: "x" }, { value: "y" }]}
                              selectCallback={props.handleArrSubVals}
                              callBackValue={[
                                "exerciseSteps",
                                i,
                                "positionDetect",
                                p,
                                "detectPoint",
                                1,
                              ]}
                            />
                          </div>
                          <div className="vt_select_hold vt_mpipe_s_short">
                            <Select
                              initVal={pose.condition}
                              placeholder="Condition"
                              selectOptions={[
                                { value: "none" },
                                { value: "more" },
                                { value: "less" },
                              ]}
                              selectCallback={props.handleArrSubVals}
                              callBackValue={[
                                "exerciseSteps",
                                i,
                                "positionDetect",
                                p,
                                "condition",
                              ]}
                            />
                          </div>
                        </div>
                      ) : pose.type === "comparePoints" ? (
                        <div key={p} className="vt_main_pose_hold">
                          {distances.map((distance, distkey) => (
                            <div key={distkey}>
                              <div className="vt_inp_included select_main">
                                <div className="select_placeholder sp_act">
                                  {distance.title + " Title"}
                                </div>
                                <input
                                  type="text"
                                  value={pose[distance.key].title}
                                  onChange={(e) =>
                                    props.handleArrSubVals(
                                      [
                                        "exerciseSteps",
                                        i,
                                        "positionDetect",
                                        p,
                                        distance.key,
                                        "title",
                                      ],
                                      e.currentTarget.value
                                    )
                                  }
                                />
                              </div>
                              <div className="vt_select_hold vt_mpipe_s_short">
                                <Select
                                  initVal={pose[distance.key].compareType}
                                  placeholder={distance.title + " Compare Type"}
                                  selectOptions={[
                                    { value: "mediaPointDistance" },
                                    { value: "userHeight" },
                                  ]}
                                  selectCallback={props.handleArrSubVals}
                                  callBackValue={[
                                    "exerciseSteps",
                                    i,
                                    "positionDetect",
                                    p,
                                    distance.key,
                                    "compareType",
                                  ]}
                                />
                              </div>
                              {pose[distance.key].compareType ===
                                "mediaPointDistance" && (
                                <>
                                  <div className="vt_select_hold vt_mpipe_s_short">
                                    <Select
                                      initVal={
                                        props.mediaPipePoints[
                                          pose[distance.key].point1 !== ""
                                            ? pose[distance.key].point1
                                            : 0
                                        ].value
                                      }
                                      placeholder={distance.title + " Point 1"}
                                      selectOptions={props.mediaPipePoints}
                                      selectCallback={props.handleArrSubVals}
                                      callBackValue={[
                                        "exerciseSteps",
                                        i,
                                        "positionDetect",
                                        p,
                                        distance.key,
                                        "point1",
                                      ]}
                                    />
                                  </div>
                                  <div className="vt_select_hold vt_mpipe_s_short">
                                    <Select
                                      initVal={
                                        props.mediaPipePoints[
                                          pose[distance.key].point2 !== ""
                                            ? pose[distance.key].point2
                                            : 0
                                        ].value
                                      }
                                      placeholder={distance.title + " Point 2"}
                                      selectOptions={props.mediaPipePoints}
                                      selectCallback={props.handleArrSubVals}
                                      callBackValue={[
                                        "exerciseSteps",
                                        i,
                                        "positionDetect",
                                        p,
                                        distance.key,
                                        "point2",
                                      ]}
                                    />
                                  </div>
                                  <div className="vt_select_hold vt_mpipe_s_short">
                                    <Select
                                      initVal={pose[distance.key].direction}
                                      placeholder={
                                        distance.title + " Direction"
                                      }
                                      selectOptions={[
                                        { value: "x" },
                                        { value: "y" },
                                      ]}
                                      selectCallback={props.handleArrSubVals}
                                      callBackValue={[
                                        "exerciseSteps",
                                        i,
                                        "positionDetect",
                                        p,
                                        distance.key,
                                        "direction",
                                      ]}
                                    />
                                  </div>
                                </>
                              )}
                              <div className="vt_inp_included select_main">
                                <div className="select_placeholder sp_act">
                                  {distance.title + " Multiply"}
                                </div>
                                <input
                                  type="text"
                                  value={pose[distance.key].multiply}
                                  onChange={(e) =>
                                    props.handleArrSubVals(
                                      [
                                        "exerciseSteps",
                                        i,
                                        "positionDetect",
                                        p,
                                        distance.key,
                                        "multiply",
                                      ],
                                      e.currentTarget.value,
                                      true
                                    )
                                  }
                                />
                              </div>
                            </div>
                          ))}
                          <div className="vt_select_hold vt_mpipe_s_short">
                            <Select
                              initVal={pose.condition}
                              placeholder="Condition"
                              selectOptions={[
                                { value: "none" },
                                { value: "more" },
                                { value: "less" },
                              ]}
                              selectCallback={props.handleArrSubVals}
                              callBackValue={[
                                "exerciseSteps",
                                i,
                                "positionDetect",
                                p,
                                "condition",
                              ]}
                            />
                          </div>
                        </div>
                      ) : pose.type === "insideGraphic" ? (
                        <div key={p} className="vt_main_pose_hold">
                          <div className="vt_inp_included select_main">
                            <div className="select_placeholder sp_act">
                              Item Index
                            </div>
                            <input
                              type="text"
                              value={pose.itemIndex}
                              onChange={(e) =>
                                props.handleArrSubVals(
                                  [
                                    "exerciseSteps",
                                    i,
                                    "positionDetect",
                                    p,
                                    "itemIndex",
                                  ],
                                  e.currentTarget.value,
                                  true
                                )
                              }
                            />
                          </div>
                          {detectPointsInx.map((detect, d) => (
                            <div
                              key={d}
                              className="vt_select_hold vt_mpipe_s_short"
                            >
                              <Select
                                initVal={
                                  props.mediaPipePoints[
                                    pose.detectPoints !== undefined &&
                                    pose.detectPoints[detect.inx] !== undefined
                                      ? pose.detectPoints[detect.inx]
                                      : 0
                                  ].value
                                }
                                placeholder={"Detect Point " + (detect.inx + 1)}
                                selectOptions={props.mediaPipePoints}
                                selectCallback={props.handleArrSubVals}
                                callBackValue={[
                                  "exerciseSteps",
                                  i,
                                  "positionDetect",
                                  p,
                                  "detectPoints",
                                  detect.inx,
                                ]}
                              />
                            </div>
                          ))}
                          {/* { <>
                        <div className="vt_select_hold vt_mpipe_s_short">
                          <Select
                            initVal={
                              props.mediaPipePoints[
                                pose.detectPoints[1] !== undefined
                                  ? pose.detectPoints[1]
                                  : 0
                              ].value
                            }
                            placeholder="Point"
                            selectOptions={props.mediaPipePoints}
                            selectCallback={props.handleArrSubVals}
                            callBackValue={[
                              "exerciseSteps",
                              i,
                              "positionDetect",
                              p,
                              "detectPoints",
                              0,
                            ]}
                          />
                        </div>
                        <div className="vt_select_hold vt_mpipe_s_short">
                          <Select
                            initVal={
                              props.mediaPipePoints[
                                pose.detectPoints[2] !== undefined
                                  ? pose.detectPoints[2]
                                  : 0
                              ].value
                            }
                            placeholder="Point"
                            selectOptions={props.mediaPipePoints}
                            selectCallback={props.handleArrSubVals}
                            callBackValue={[
                              "exerciseSteps",
                              i,
                              "positionDetect",
                              p,
                              "detectPoints",
                              1,
                            ]}
                          />
                        </div>
                      </>} */}
                          <div className="vt_select_hold vt_mpipe_s_short">
                            <Select
                              initVal={pose.compareDirection}
                              placeholder="Compare Direction"
                              selectOptions={[
                                { value: "x" },
                                { value: "y" },
                                { value: "inside both" },
                              ]}
                              selectCallback={props.handleArrSubVals}
                              callBackValue={[
                                "exerciseSteps",
                                i,
                                "positionDetect",
                                p,
                                "compareDirection",
                              ]}
                            />
                          </div>
                          <div className="vt_inp_included select_main">
                            <div className="select_placeholder sp_act">
                              Detection Grow
                            </div>
                            <input
                              type="text"
                              value={
                                pose.detectionGrow ? pose.detectionGrow[0] : ""
                              }
                              onChange={(e) =>
                                props.handleArrSubVals(
                                  [
                                    "exerciseSteps",
                                    i,
                                    "positionDetect",
                                    p,
                                    "detectionGrow",
                                    0,
                                  ],
                                  e.currentTarget.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="vt_select_hold vt_mpipe_s_short">
                            <Select
                              initVal={
                                pose.detectionGrow ? pose.detectionGrow[1] : ""
                              }
                              placeholder="Grow Direction"
                              selectOptions={[
                                { value: "left" },
                                { value: "right" },
                                { value: "top" },
                                { value: "bottom" },
                              ]}
                              selectCallback={props.handleArrSubVals}
                              callBackValue={[
                                "exerciseSteps",
                                i,
                                "positionDetect",
                                p,
                                "detectionGrow",
                                1,
                              ]}
                            />
                          </div>
                          <div className="vt_select_hold vt_mpipe_s_short">
                            <Select
                              initVal={pose.condition}
                              placeholder="Condition"
                              selectOptions={[
                                { value: "none" },
                                { value: "more" },
                                { value: "less" },
                              ]}
                              selectCallback={props.handleArrSubVals}
                              callBackValue={[
                                "exerciseSteps",
                                i,
                                "positionDetect",
                                p,
                                "condition",
                              ]}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  )
                )}
              {/* {props.virtualState.exerciseSteps[0].detectType === "positionDetect" && (
              <div
                className="vt_add vt_add_mid"
                onClick={() => props.addGraphOrAction(["exerciseSteps", i, "positionDetect"])}
              >
                Add Condition
              </div>
            )} */}
              {/* {item.angleMonitoring &&
              item.angleMonitoring.map((angle, a) => (
                <div key={a} className="vt_angle_hold">
                  <input
                    type="text"
                    style={{ border: "none", padding: 0 }}
                    value={angle.name}
                    placeholder="Angle Name"
                    className="e_create_input vt_inp_included select_main"
                    onChange={(e) =>
                      props.handleArrSubVals(["exerciseSteps", i, "angleMonitoring", a, "name"], e.currentTarget.value)
                    }
                  />
                  <div className="vt_mpipe_phold select_placeholder sp_act">Media Pipe Points</div>
                  {angle.angle.map((angleVal, v) => (
                    <div key={v} className="vt_select_hold vt_mpipe_shold">
                      <Select
                        initVal={props.mediaPipePoints[angleVal].value}
                        selectCallback={props.handleArrSubVals}
                        selectOptions={props.mediaPipePoints}
                        callBackValue={["exerciseSteps", i, "angleMonitoring", a, "angle", v]}
                      />
                    </div>
                  ))}
                  <div>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Error Angle</div>
                      <input
                        type="text"
                        value={angle.errorAngle}
                        onChange={(e) =>
                          props.handleArrSubVals(
                            ["exerciseSteps", i, "angleMonitoring", a, "errorAngle"],
                            e.currentTarget.value,
                            true
                          )
                        }
                      />
                    </div>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Critical Angle</div>
                      <input
                        type="text"
                        value={angle.criticalAngle}
                        onChange={(e) =>
                          props.handleArrSubVals(
                            ["exerciseSteps", i, "angleMonitoring", a, "criticalAngle"],
                            e.currentTarget.value,
                            true
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              ))}
            <div
              className="vt_add vt_add_mid"
              onClick={() => props.addGraphOrAction(["exerciseSteps", i, "angleMonitoring"])}
            >
              Add Angle
            </div> */}
              <div
                className="vt_add vt_add_left"
                onClick={() => props.openCloseSubform("singleActions", i)}
              >
                Add/Edit Actions
              </div>
              <div
                className="vt_add vt_add_left"
                onClick={() => props.openCloseSubform("onScreenGraphics", i)}
              >
                Add/Edit Graphics
              </div>
              <div
                className="vt_add vt_inp_del_act"
                onClick={() => props.removeExerciseStep(i)}
              >
                Delete Step
              </div>
            </div>
          ))}
        <div className="vt_add" onClick={() => props.addExerciseStep()}>
          Add Step
        </div>
      </div>
      <div className={"virtual_hold" + (props.errorStep ? " sb_sec_err" : " ")}>
        <div className="vth_title">Custom Variables</div>
        <div className="exercise_steps_row">
          {Object.entries(props.data).map(([key, value], index) => (
            <div key={key}>
              <div
                style={{ display: "inline-block" }}
                className="e_create_input vt_inp_detached select_main customm_inpts_width"
              >
                {true && (
                  <div className="select_placeholder sp_act">Variable Name</div>
                )}
                <input
                  type="text"
                  //name={key}
                  value={
                    key === "NaN" &&
                    index === Object.keys(props.data).length - 1
                      ? ""
                      : key
                  }
                  placeholder="Variable Name"
                  className={true ? " " : "vt_input_inact"}
                  onChange={(e) => props.handleInputChange(e, key, "key")}
                  onFocus={() => handleFocus(index)}
                  autoFocus={focusedIndex === index}
                />
              </div>
              <div
                key={key}
                style={{ display: "inline-block" }}
                className="e_create_input vt_inp_detached select_main customm_inpts_width"
              >
                {true && <div className="select_placeholder sp_act">Value</div>}
                <input
                  type="text"
                  //name={key}
                  value={
                    value === "" && index === Object.keys(props.data).length - 1
                      ? ""
                      : value
                  }
                  placeholder="Value"
                  className={true ? " " : "vt_input_inact"}
                  onChange={(e) => props.handleInputChange(e, key, "value")}
                  onFocus={() => handleFocus(index)}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="vt_add" onClick={() => props.handleAddData()}>
          Add Custom Variable
        </div>
      </div>
    </div>
  );
};

export default VirtualMainForm;
